import { useState, useEffect } from 'react';
import { supabase } from '../../../integrations/supabase/client';

export interface WhatsAppConnection {
  id: string;
  nombre_instancia: string;
  numero_telefono: string;
  estado: string;
}

export function useWhatsAppConnections() {
  const [connections, setConnections] = useState<WhatsAppConnection[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchConnections();
  }, []);

  async function fetchConnections() {
    try {
      setLoading(true);
      const { data: { user } } = await supabase.auth.getUser();

      if (!user) {
        throw new Error('Usuario no autenticado');
      }

      const result = await (supabase as any)
        .from('whatsapp_connections')
        .select('*')
        .eq('user_id', user.id)
        .eq('estado', 'connected')
        .order('created_at', { ascending: false });

      if (result.error) throw result.error;

      // Map the data to our interface
      const mappedData: WhatsAppConnection[] = (result.data || []).map((item: any) => ({
        id: item.id,
        nombre_instancia: item.nombre_instancia,
        numero_telefono: item.numero_telefono,
        estado: item.estado
      }));

      setConnections(mappedData);
    } catch (err) {
      console.error('Error al cargar conexiones:', err);
      setError(err instanceof Error ? err.message : 'Error desconocido');
    } finally {
      setLoading(false);
    }
  }

  return { connections, loading, error, refetch: fetchConnections };
}
